import type { ReactNode } from 'react';
import { Fragment } from 'react';

import { StyledTable } from './Table.styled';

type Props = {
  qaId?: string;
  headings: ReactNode[];
  trQaId?: string;
  data: ReactNode[][] | ReactNode[];
  expansions?: (ReactNode | null)[];
  expansionTrQaId?: string;
  initialIndex?: number;
  className?: string;
};

export function Table({
  headings,
  data,
  trQaId,
  expansions,
  expansionTrQaId,
  initialIndex = 0,
  qaId,
  className,
}: Props) {
  return (
    <StyledTable data-qa-id={qaId} className={className}>
      <thead>
        <tr>
          {headings.map((heading, headingIndex) => (
            <th key={`heading-${headingIndex}`}>{heading}</th>
          ))}
        </tr>
      </thead>

      <tbody>
        {data.map((row, rindex) => (
          <Fragment key={`row-${rindex}`}>
            <tr data-qa-id={trQaId} data-row-index={rindex + initialIndex}>
              {Array.isArray(row)
                ? row.map((cell, cellIndex) => (
                    <td key={`cell-${rindex}-${cellIndex}`}>{cell}</td>
                  ))
                : row}
            </tr>
            {expansions?.[rindex] ? (
              <tr data-qa-id={expansionTrQaId} data-expansion>
                <td colSpan={headings.length}>{expansions[rindex]}</td>
              </tr>
            ) : null}
          </Fragment>
        ))}
      </tbody>
    </StyledTable>
  );
}
